<template>
  <slot></slot>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, provide, ref } from 'vue'
import type { SidebarContextType } from './type'
import { ProviderKeys } from '@/app/providers/provider-keys.ts'

const isExpanded = ref(true)
const isMobileOpen = ref(false)
const isMobile = ref(false)
const activeItem = ref<string | null>(null)

const handleResize = () => {
  const mobile = window.innerWidth < 768
  isMobile.value = mobile
  if (!mobile) {
    isMobileOpen.value = false
  }
}

onMounted(() => {
  handleResize()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => window.removeEventListener('resize', handleResize))

const toggleSidebar = () => {
  if (isMobile.value) {
    isMobileOpen.value = !isMobileOpen.value
  } else {
    isExpanded.value = !isExpanded.value
  }
}

const toggleMobileSidebar = () => (isMobileOpen.value = !isMobileOpen.value)

const closeMobileSidebar = () => {
  isMobileOpen.value = false
}

const setActiveItem = (item: string | null) => (activeItem.value = item)

const context: SidebarContextType = {
  isExpanded: computed(() => (isMobile.value ? false : isExpanded.value)),
  isMobileOpen,
  activeItem,
  toggleSidebar,
  toggleMobileSidebar,
  closeMobileSidebar,
  setActiveItem,
}

provide(ProviderKeys.AppSidebar, context)
</script>
